export default {
  'form.text.title': '',
  'form.text.postulationDone': 'Solicitud completada satisfactoriamente',
  'form.text.number': 'Nro. Solicitud: {name}',
  'form.text.documents': 'Documentos',
  'form.message.noCaptcha': 'Error de validación reCaptcha, pruebe nuevamente en unos segundos.',
  'form.text.continueDone': '¡La acción se ha completado satisfactoriamente!',
  'form.text.cleanForm': 'Borrar formulario',
  'form.text.refresh.title': '¿Desea borrar el formulario?',
  'form.text.refresh.content': 'Esta acción eliminará tus respuestas y no se puede deshacer.',
  'form.text.telegramUser': 'Identificador Telegram',
  'form.text.userName': 'Usuario',
  'form.text.userFirstName': 'Nombres',
  'form.text.userLastNames': 'Apellidos',
  'form.text.fullName': 'Nombre Completo',
  'form.text.email': 'Correo',
  'form.text.hash': 'Hash',
  'form.text.token': 'Token',
  'form.telegram.account': 'Confirmar Cuenta',
  'form.telegram.title': 'Confirme que desea enlazar la cuenta de Telegram con su cuenta de AUTOMY',
  'form.telegram.group': 'Telegram / Información Usuario',
  'form.telegram.automy': 'Automy / Información Usuario',
  'form.telegram.help': `Al confirmar estaría de acuerdo en que AUTOMY le envíe notificaciones sobre solicitudes a su cuenta de Telegram`,
  'form.telegram.message': `La información del enlace de Telegram ha sido verificado correctamente`,
  'form.telegram.unauthorized': `Debe autenticarse para verificar su cuenta de Telegram.`,
};
